import { action, computed, makeObservable, observable } from "mobx"
import WORDS from "./WORDS"


export const Rating = {
    ABSENT: "ABSENT",
    PRESENT: "PRESENT",
    CORRECT: "CORRECT"
}

export function getTileId(rowIndex, index)
{
    return "t-" + rowIndex + "-" + index
}

export class Row {
    @observable
    id

    @observable
    guess = [
        "",
        "",
        "",
        "",
        ""
    ]
    @observable
    rating = [
        Rating.ABSENT,
        Rating.ABSENT,
        Rating.ABSENT,
        Rating.ABSENT,
        Rating.ABSENT
    ]

    @observable
    index = -1

    constructor(index)
    {
        this.index = index
        makeObservable(this)
    }

    @action
    cycleRating(index)
    {
        const rating = this.rating[index];
        switch (rating)
        {
            case Rating.ABSENT:
                this.rating[index] = Rating.PRESENT
                break;
            case Rating.PRESENT:
                this.rating[index] = Rating.CORRECT
                break;
            case Rating.CORRECT:
                this.rating[index] = Rating.ABSENT
                break;
        }

        console.log("Rating", this.rating[index])
    }
    @action
    setValue(index, value)
    {
        console.log("setValue", this, index, value)
        this.guess[index] = value.toUpperCase()
        if (index < 4)
        {
            
        }
    }

    @action
    rate(appState)
    {
        const s = this.guess.join("");
        console.log("RATE",  "'"+ s + "'")
        const { word } = appState;

        for (let i=0; i < 5; i++)
        {
            const c1 = s[i]
            const c2 = word[i]

            if (c1 === c2)
            {
                this.rating[i] = Rating.CORRECT
            }
            else if (word.indexOf(c1) >= 0)
            {
                this.rating[i] = Rating.PRESENT
            }
            else
            {
                this.rating[i] = Rating.ABSENT
            }
        }

        this.word = WORDS[0|Math.random() * WORDS.length]
    }

}


export class AppState {
    @observable
    rows = []

    @observable
    word

    constructor()
    {
        makeObservable(this)

        this.newWord()

        for (let i = 0; i < 6; i++)
        {
            this.rows.push(new Row(i))
        }
    }
    @action
    newWord()
    {
        this.word = WORDS[0|Math.random() * WORDS.length]
    }


    @computed
    get words()
    {
        const banned = new Set()
        const bannedOnPos = [new Set(),new Set(),new Set(),new Set(),new Set()]
        const correctOnPos = [null,null,null,null,null]
        const present = new Set()

        const { rows } = this;
        for (let i = 0; i < rows.length; i++)
        {
            const {guess, rating} = rows[i]
            for (let j = 0; j < guess.length; j++)
            {
                const c = guess[j]
                const r = rating[j]

                if (c)
                {
                    if (r === Rating.ABSENT)
                    {
                        banned.add(c)
                    }
                    else if (r === Rating.PRESENT)
                    {
                        bannedOnPos[j].add(c)
                        present.add(c)
                    }
                    else if (r === Rating.CORRECT)
                    {
                        correctOnPos[j] = c
                    }
                }
            }
        }

        console.log({banned, bannedOnPos, correctOnPos})

        return WORDS.filter(
            s => {
                for (let i=0; i < 5; i++)
                {
                    const c = s[i]
                    if (correctOnPos[i] && correctOnPos[i] !== c)
                    {
                        return false
                    }
                    if (bannedOnPos[i].has(c))
                    {
                        return false
                    }
                    if (banned.has(c))
                    {
                        return false
                    }

                }

                for (let c2 of present)
                {
                    if (s.indexOf(c2) < 0)
                    {
                        return false
                    }
                }
                return true
            }
        )
    }

    @action
    choose(word)
    {
        const { rows } = this;
        const row = rows.find(r => r.guess.some(c => !c))
        if (row)
        {
            row.guess = word.split("")
        }
        row.rate(this)
    }
}
